import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { HelmetProvider } from "react-helmet-async";
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  // Hydrate pre-rendered HTML (production, after react-snap)
  hydrateRoot(rootElement, app);
} else {
  // Normal render (development)
  createRoot(rootElement).render(app);
}

reportWebVitals();